import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserType } from '@viso/core/enums';
import { Environment, Response } from '@viso/core/models';
import { ENVIRONMENT } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment
  ) { }

  sendOtp(request) {
    if (request.email_id && request.accessToken) {
      return this.loginOrRegisterWithEmail(request);
    }
    // TODO: this will be created dynamically from client side
    request.hash =
      '$2y$10$VzwQgY71dtJfWZcOggIpZ.glIbv5btEk5CSEx9cUpiltOoHGu3wDe';
    request.token = '923736';
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/mobile-otp`,
      request
    );
  }

  sendOtpOnEmail(request: { phone: string, user_type: string }) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/email-otp`,
      request
    );
  }

  sendOtpOnRegistration(request: { phone: string }) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/send-otp-registration`,
      request
    );
  }

  verifyOtp(body) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/verify-otp`,
      body
    );
  }

  updatePhoneOtp(request) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/update-phone-otp`,
      request
    );
  }
  
  verifyUpdatePhone(request) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/verify-update-phone`,
      request
    );
  }
  

  deleteAccount() {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/delete-account`, null
    );
  }

  loginOrRegisterWithEmail(request: { email_id: string, user_type: string, name?: string}) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/auth/googleAuth`,
      request
    );
  }

}
